import {useEffect, useState} from 'react'

type MaintenanceWindow = {
  startUtcMs: number
  endUtcMs: number
  startLabel: string
  endLabel: string
}

// Maintenance windows expressed in Vietnam time (GMT+7), converted to UTC for comparison.
const MAINTENANCE_WINDOWS: MaintenanceWindow[] = [
  {
    // 16:00 26/05/2026 GMT+7 = 09:00 26/05/2026 UTC
    // 16:30 26/05/2026 GMT+7 = 09:30 26/05/2026 UTC
    startUtcMs: Date.UTC(2026, 4, 26, 9, 0, 0),
    endUtcMs: Date.UTC(2026, 4, 26, 9, 30, 0),
    startLabel: '16:00 ngày 26/05/2026',
    endLabel: '16:30 ngày 26/05/2026',
  },
  {
    // 06:30 30/05/2026 GMT+7 = 23:30 29/05/2026 UTC
    // 18:30 31/05/2026 GMT+7 = 11:30 31/05/2026 UTC
    startUtcMs: Date.UTC(2026, 4, 29, 23, 30, 0),
    endUtcMs: Date.UTC(2026, 4, 31, 11, 30, 0),
    startLabel: '06:30 ngày 30/05/2026',
    endLabel: '18:30 ngày 31/05/2026',
  },
]

const CHECK_INTERVAL_MS = 30_000

const getActiveWindow = (): MaintenanceWindow | null => {
  const now = Date.now()
  return (
    MAINTENANCE_WINDOWS.find((w) => now >= w.startUtcMs && now < w.endUtcMs) ?? null
  )
}

export const MaintenanceDialog = () => {
  const [activeWindow, setActiveWindow] = useState<MaintenanceWindow | null>(getActiveWindow())

  useEffect(() => {
    const check = () => setActiveWindow(getActiveWindow())
    check()
    const id = window.setInterval(check, CHECK_INTERVAL_MS)
    return () => window.clearInterval(id)
  }, [])

  useEffect(() => {
    if (!activeWindow) return
    const previousOverflow = document.body.style.overflow
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = previousOverflow
    }
  }, [activeWindow])

  if (!activeWindow) return null

  return (
    <div
      role='dialog'
      aria-modal='true'
      aria-labelledby='maintenance-dialog-title-vi'
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 99999,
        backgroundColor: 'rgba(0, 0, 0, 0.65)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '1rem',
      }}
    >
      <div
        style={{
          backgroundColor: '#fff',
          borderRadius: '0.75rem',
          maxWidth: 560,
          width: '100%',
          maxHeight: '90vh',
          overflowY: 'auto',
          padding: '2rem',
          boxShadow: '0 10px 40px rgba(0, 0, 0, 0.25)',
        }}
      >
        <section lang='vi' style={{textAlign: 'center'}}>
          <h3 id='maintenance-dialog-title-vi' className='fw-bold mb-4' style={{color: '#2c8d96'}}>
            Bảo trì hệ thống
          </h3>
          <p className='text-dark mb-3'>
            Hệ thống sẽ thực hiện bảo trì theo lịch từ <b>{activeWindow.startLabel}</b> đến{' '}
            <b>{activeWindow.endLabel}</b>.
          </p>
          <p className='text-dark mb-3'>
            Trong thời gian này, hệ thống sẽ tạm thời không thể truy cập. Chúng tôi xin lỗi vì sự
            bất tiện này và chân thành cảm ơn sự thông cảm của Quý khách.
          </p>
          <p className='text-dark mb-0'>
            Hệ thống sẽ hoạt động trở lại ngay sau khi hoàn tất bảo trì.
          </p>
        </section>
      </div>
    </div>
  )
}
